import React from 'react';
import {Create, SimpleForm, NumberInput, DateInput, Toolbar, SaveButton, minValue, maxValue} from 'react-admin';

const CashbackCreateToolbar = props => (
    <Toolbar {...props}>
        <SaveButton
            label="save"
            redirect="list"
            submitOnEnter={true}
        />
    </Toolbar>
);

const percentageValidate = [minValue(0), maxValue(100)];

class CashbackCreate extends React.Component {
    render() {
        return (
            <Create {...this.props}>
                <SimpleForm toolbar={<CashbackCreateToolbar />}>
                    <NumberInput source="accrual" label="Accrual (0 - 100) %" validate={percentageValidate} />
                    <NumberInput source="usageLimit" label="Usage Limit (0 - 100) %" validate={percentageValidate} />
                    <NumberInput source="validityPeriod" label="Validity Period (Days)" />
                    <DateInput source="startedAt" label="Start Date" />
                    <DateInput source="endedAt" label="End Date" />
                </SimpleForm>
            </Create>
        );
    }
}

export default CashbackCreate;
